module.exports = __webpack_public_path__ + "static/media/Z5.21af0912.jpg";